export const APP_ROUTES = {
  HOME: '/',
  LOGOUT: '/logout',
  LOGIN: '/login',
  SHOWCASE: '/showcase',
  SYSTEM_MESSAGES: '/system-messages',
  ACCOUNT_SETTINGS: '/account-settings',

  DEVICE_ORDER: '/device-orders/devices/:id',
  DEVICE_ORDERS: '/device-orders/devices',

  EMPLOYEE: '/employees/:costObjectId',
  EMPLOYEES_SALARY_DEDUCTION_APPLICATION: '/employees/salary-deduction/:id',
  EMPLOYEES_SALARY_DEDUCTION_APPLICATIONS: '/employees/salary-deduction',
  EMPLOYEES: '/employees',

  HARDWARE_ECOM_POLICY_ORDER_LIST: '/hardware/orders',
  HARDWARE_SHOP: '/hardware/new-order',
  HARDWARE_ECOM_POLICY_NEW: '/hardware/policy/new',
  HARDWARE_ECOM_POLICY_LIST: '/hardware/policy/list',
  HARDWARE_ECOM_POLICY: '/hardware/policy/:ecomPolicyId',
  HARDWARE_ECOM_POLICY_ORDER: '/hardware/orders/:ecomPolicyOrderId',
  HARDWARE_INJURY_REPORT: '/hardware/injury-reports/:id',
  HARDWARE_INJURY_REPORTS: '/hardware/injury-reports',
  HARDWARE_ASSET_LOCATION_LIST: '/hardware/asset-locations',
  HARDWARE_ASSET_LOCATION: '/hardware/asset-locations/:assetLocationId',
  HARDWARE_ASSETS_NEW: '/hardware/assets/new',
  HARDWARE_ASSET: '/hardware/:id',
  HARDWARE_ASSETS: '/hardware',
  HARDWARE_TRADE_IN: '/hardware/trade-in',
  HARDWARE_TRADE_IN_ORDER_DETAILS: '/hardware/trade-in/orders/:orderId',
  HARDWARE_ASSET_LOCATION_NEW: '/hardware/asset-locations/new',

  REPORTS_SETUP_EXPORT_SETTINGS: '/reports/setup-export-settings',
  REPORTS_DRILL_DOWN: '/reports/drill-down',
  REPORTS_DRILL_DOWN_SERVICE: '/reports/drill-down/service',
  REPORTS_DRILL_DOWN_SERVICE_CATEGORY: '/reports/drill-down/service/category',
  REPORTS_DRILL_DOWN_SERVICE_CATEGORY_GROUPS: '/reports/drill-down/service/category/groups',
  REPORTS_DRILL_DOWN_SERVICE_CATEGORY_GROUPS_COST_OBJECTS:
    '/reports/drill-down/service/category/groups/cost-objects',
  REPORTS_DRILL_DOWN_DEPARTMENT: '/reports/drill-down/department',
  REPORTS_DRILL_DOWN_DEPARTMENT_COST_OBJECT: '/reports/drill-down/department/cost-objects',
  REPORTS_DRILL_DOWN_DEPARTMENT_COST_OBJECT_PRODUCTS:
    '/reports/drill-down/department/cost-objects/products',
  REPORTS_DRILL_DOWN_COST_OBJECT: '/reports/drill-down/cost-object',
  REPORTS_DRILL_DOWN_COST_OBJECT_PRODUCT: '/reports/drill-down/cost-object/product',
  REPORTS_DRILL_DOWN_CATEGORIES: ':type/:typeId',
  REPORTS_DRILL_DOWN_GROUPS: ':type/:typeId/category/:categoryId',
  REPORTS_DRILL_DOWN_PRODUCTS: ':type/:typeId/category/:categoryId/group/:groupId',
  REPORTS_INVOICES: '/reports/invoices',
  REPORTS: '/reports',

  SUBSCRIPTIONS_NEW_SUBSCRIPTION_LIST_ADD: '/subscriptions/new',
  SUBSCRIPTIONS_SUBSCRIPTION: '/subscriptions/:subscriptionId',
  SUBSCRIPTIONS_TERMINATION_LIST_ADD: '/subscriptions/terminations/new',
  SUBSCRIPTIONS_TERMINATION: '/subscriptions/terminations/:terminationOrderId',
  SUBSCRIPTIONS_TERMINATION_LIST: '/subscriptions/terminations',
  SUBSCRIPTIONS_TELE_POLICIES: '/subscriptions/tele-policies',
  SUBSCRIPTIONS_NEW_SUBSCRIPTION_LIST: '/subscriptions',

  // ADMIN
  ADMIN: '/admin',
  ADMIN_ADDRESSES: '/admin/addresses',
  ADMIN_TELE_POLICIES: '/admin/tele-policies',
  ADMIN_SMS_SENDER: '/sms-sender',
  ADMIN_COST_OBJECTS: '/admin/cost-objects',
  ADMIN_TEXT_TEMPLATES: '/admin/text-templates',
  ADMIN_USERS: '/admin/users',
  ADMIN_EMPLOYEE_CONSENTS: '/admin/employee-consent',
  ADMIN_EMPLOYEE_CONSENT_REPORT: '/admin/employee-consent/:consentId/report',
  ADMIN_DRILL_DOWN: '/admin/drill-down',
  ADMIN_DRILL_DOWN_CATEGORIES: ':type/:typeId',
  ADMIN_DRILL_DOWN_GROUPS: ':type/:typeId/category/:categoryId',
  ADMIN_DRILL_DOWN_PRODUCTS: ':type/:typeId/category/:categoryId/group/:groupId',
  ADMIN_DEPARTMENTS: '/admin/departments',
  ADMIN_INVOICES: '/admin/invoices',
  ADMIN_TRADE_IN: '/admin/trade-in',
  ADMIN_FEATURES: '/admin/features',
  ADMIN_APP_MESSAGE: '/admin/app-message',
  ADMIN_SETTINGS: '/admin/settings',
  ADMIN_WORKFLOWS: '/admin/workflows',

  // MENU
  MENU_ADMIN: '/menu/admin',
  MENU_SUBSCRIPTIONS: '/menu/subscriptions',
  MENU_HARDWARE: '/menu/hardware',
  MENU_EMPLOYEES: '/menu/employees',
  MENU_REPORTS: '/menu/reports',
}
